module.exports = __webpack_public_path__ + "img/Redwoods National Park depth.36bc4464.jpg";